/* Material CircularProgressIndicator equivalents.
 *
 * Flutter sizes used in the app:
 *   50x50 primary  — route gate + alert-list loader
 *   23x23 text-col — inside FFButtonWidget while awaiting onPressed
 * Stroke width is 4.0 in Flutter regardless of diameter. */

import { tr } from '@/i18n'

interface SpinnerProps {
  size?: number
  color?: string
}

export function Spinner({ size = 50, color = 'var(--primary)' }: SpinnerProps) {
  // viewBox 50 with r=20 leaves room for the 4px stroke, matching Flutter's
  // inner-padded arc.
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      style={{ animation: 'spinnerRotate 1.4s linear infinite' }}
      role="progressbar"
      aria-label={tr.map.loading}
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="butt"
        style={{ animation: 'spinnerDash 1.4s ease-in-out infinite' }}
      />
    </svg>
  )
}

/** The 23x23 spinner FFButtonWidget swaps in for the label. */
export function ButtonSpinner({ color = '#ffffff' }: { color?: string }) {
  return <Spinner size={23} color={color} />
}

/** SpinKitSquareCircle(color: #FF77B7, size: 50) — map route loading. */
export function SquareCircleSpinner({
  size = 50,
  color = 'var(--primary)',
}: SpinnerProps) {
  return (
    <div
      role="progressbar"
      aria-label={tr.map.loadingRoute}
      style={{
        width: size,
        height: size,
        background: color,
        animation: 'squareCircle 1s ease-in-out infinite',
      }}
    />
  )
}
